import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { UnitsOfMeasure } from '../../../model/administration.model';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../../services/inventory.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdministratorService } from '../../../services/administrator.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import _ from 'lodash';
import { MessageService } from 'primeng/api';
import { GetproductLookupComponent } from '../getproduct-lookup/getproduct-lookup.component';
import { billofmaterial } from '../../../model/inventory.model';
import { SalesService } from '../../../services/sales.service';

@Component({
  selector: 'app-billofmaterial-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  templateUrl: './BillOfMaterial-lookup.component.html',
  styleUrl: './BillOfMaterial-lookup.component.scss'
})
export class BillOfMaterialLookupComponent implements OnInit {
  @Input() bomId: any;
  filteredProducts: any[] = [];
  products: [] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  filterProductList: any[] = [];
  saveData: any;
  filterproduct: any[] = []
  filteruom: UnitsOfMeasure[] = [];
  UOMDropdown: UnitsOfMeasure[] = [];
  productDropdown: any[] = [];
  submitted: any;
  isEdit: boolean = false;
  isEditModeComponent: boolean = false;
  BOMid: number = 0;
  bomLineItemId: number = 0;
  uom: any;
  quantity: number = 0;
  comment: any;


  constructor(private route: Router, private router: ActivatedRoute, private inventoryService: InventoryService
    , public ref: DynamicDialogRef, public dialogService: DialogService, private salesService: SalesService,
    private administratorService: AdministratorService, private config: DynamicDialogConfig
    , private billofmaterialservice: InventoryService, private messageService: MessageService, private fb: FormBuilder) {
  }


  ngOnInit(): void {
    const todayDate = new Date();
    this.billOfMaterialFormLineItem.controls['createdDate'].setValue(todayDate);
    this.billOfMaterialFormLineItem.controls['createdBy'].setValue(localStorage.getItem('username'));
    this.getUOM();
    this.bomId = this.config.data?.bomId;
    this.getProducts();
    // this.getSystemConfig();
    this.edit();
  }

  billOfMaterialFormLineItem = new FormGroup({
    product: new FormControl(),
    productId: new FormControl(),
    productCode: new FormControl('', Validators.required),
    compQuantity: new FormControl(' ', Validators.required),
    unitsOfMeasureId: new FormControl(),
    WarehouseId: new FormControl(),
    quantityAvailable: new FormControl(),
    productSize: new FormControl(),
    bomId: new FormControl(),
    make: new FormControl(),
    mkfpartid: new FormControl(),
    specification: new FormControl(),
    unitsOfMeasureCode: new FormControl('', Validators.required),
    UnitOfMeasure: new FormControl(),
    productPrice: new FormControl(),
    comment: new FormControl(),
    IsActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl,

  })

  getProducts() {
    this.billofmaterialservice.getProducts(this.pageRequest).subscribe({
      next: (response: any) => {
        const filteredProducts = response.products.filter((product: any) => product.productType === 'RM1113');
        this.products = filteredProducts.map((product: any) => ({
          ...product,
          formattedCode: `${product.productCode} - ${product.productName}`
        }));
        this.productDropdown = this.products;
      }
    });
  }

  get isbillOfMaterialFormLineItemValid() {
    return this.billOfMaterialFormLineItem.get('productCode')?.valid && this.billOfMaterialFormLineItem.get('unitsOfMeasureCode')?.valid && this.billOfMaterialFormLineItem.get('compQuantity')?.valid && this.billOfMaterialFormLineItem.get('weight')?.valid;
  }

  setProduct(data: any) {
    if (this) {
      const productDisplay = data.value.productName;
      const productSize = data.value.productSize;
      const specification = data.value.productSpecification;
      const UnitOfMeasure = data.value.unitsOfMeasure;
      const UnitsofMeasureId = data.value.unitsofMeasureId;
      this.billOfMaterialFormLineItem.controls.unitsOfMeasureId.setValue(UnitsofMeasureId);
      this.billOfMaterialFormLineItem.controls.unitsOfMeasureCode.setValue(_.toString(UnitOfMeasure));
      this.billOfMaterialFormLineItem.controls.product.setValue(productDisplay);
      this.billOfMaterialFormLineItem.controls.productSize.setValue(productSize);
      this.billOfMaterialFormLineItem.controls.specification.setValue(specification);
      this.billOfMaterialFormLineItem.controls.productCode.setValue(data.value.formattedCode);
      this.billOfMaterialFormLineItem.controls.productId.setValue(data.value.productId);
      this.billOfMaterialFormLineItem.controls.make.setValue(data.value.make);
      this.billOfMaterialFormLineItem.controls.mkfpartid.setValue(data.value.mkfpartid);
      this.billOfMaterialFormLineItem.controls.comment.setValue(data.value.productcomment);
    }
  }

  filterProduct(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.productDropdown as any[]).length; i++) {
      let product = (this.productDropdown as any[])[i];
      if (product.productCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(product);
      }
    }
    this.filterproduct = filtered;
  }

  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
      }
    });
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(uom);
      }
    }
    this.filteruom = filtered;
  }

  onUnitOfMeasureSelect(event: any) {
    if (this) {
      this.billOfMaterialFormLineItem.controls.unitsOfMeasureCode.setValue(_.toString(event.value.unitsofMeasure));
      this.billOfMaterialFormLineItem.controls.unitsOfMeasureId.setValue(event.value.unitsofMeasureId);
    }
  }

  cancel(data: any) {
    this.ref.close();
  }

  Reset() {
    this.billOfMaterialFormLineItem.reset()
  }

  AddBOM(data: any) {

    if (data.productCode == undefined) {
      data.productCode = data.product.productCode + " - " + data.product.productName;
    }

    if (!data.productCode) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Product is required.'
      });
      return;
    }

    if (data.compQuantity == null || String(data.compQuantity).trim() === '') {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Quantity is required.'
      });
      return;
    }

    if (!data.unitsOfMeasureCode) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Units of Measure is required.'
      });
      return;
    }

    if (!data.productPrice) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'productPrice is required.'
      });
      return;
    }

    data.totReqQuantity = (parseFloat(data.wastage) || 0) + (parseFloat(data.compQuantity) || 0);
    data.updatedBy = localStorage.getItem('username');
    data.bomId = this.BOMid;
    if (this.bomLineItemId !== 0) {
      data.bomLineItemId = this.bomLineItemId;
    }
    data.isdeletecomponent = false;

    if (data.quantityAvailable === null) {
      data.quantityAvailable = 0;
    }

    if (data.quantityOnHand === null) {
      data.quantityOnHand = 0;
    }

    this.saveData = data;

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'BillOfMaterial Line Items Created Successfully.'
    });

    this.ref.close(this.saveData);
  }


  onKeyDownQty(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', '.', 'Delete'];
    if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  get formControls() {
    return this.billOfMaterialFormLineItem.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.billOfMaterialFormLineItem.invalid && !this.isbillOfMaterialFormLineItemValid) {
      isValid = false;
    }

    if (!isValid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
    }
    return isValid;
  }



  edit() {
    this.isEditModeComponent = true;
    let data = this.config.data?.lineItemData;

    if (data === undefined) {
      this.isEditModeComponent = false;
      this.isEdit = false;
    } else {
      this.isEditModeComponent = true;
      this.isEdit = true;
    }

    if (data) {
      this.BOMid = data.bomId;
      this.bomLineItemId = data.bomLineItemId;
      this.billOfMaterialFormLineItem.patchValue({
        product: data.product,
        productId: data.productId,
        productCode: data.productCode,
        productPrice: data.productPrice,
        compQuantity: data.compQuantity,
        make: data.make,
        mkfpartid: data.mkfpartid,
        specification: data.specification,
        unitsOfMeasureId: data.unitsOfMeasureId,
        unitsOfMeasureCode: data.unitsOfMeasureCode,
        UnitOfMeasure: data.unitsOfMeasureCode,
        comment: data.comment,
        productSize: data.productSize,
        quantityAvailable: data.quantityAvailable
      });
    }
  }

  getProduct() {
    this.ref = this.dialogService.open(GetproductLookupComponent, {
      header: 'Product List',
      width: '60%',
      data: { Material: 'FG1112' }
    });
    this.ref.onClose.subscribe((data: billofmaterial) => {
      if (data) {
        this.billOfMaterialFormLineItem.patchValue({
          productId: data.productId,
          productCode: `${data.productId} - ${data.productName}`,
          productSize: data.productSize,
          specification: data.productSpecification
        });
      }
    });
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any[]) => {
        if (data) {
          this.filterProductList = data
            .filter(product => product.productType === 'RM1113')
            .map(product => ({
              ...product,
              formattedCode: `${product.productCode} - ${product.productName}`,
            }));

        }
      },
      (error: any) => {
        console.error('Error fetching products:', error);
      }
    );
  }

}
